/*
The footer component.

Customize the default footer component or create your own here.
*/

<template>
  <bottom
    variant="light"
    class="shadow-sm"
  />
</template>

<script>
import Bottom from '@/components/piveau-ui-core/Bottom';

export default {
  name: 'TheFooter',
  components: {
    Bottom
  }
}
</script>

